(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/nova/callout.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/nova/callout.js');
"use strict";

const _excluded = ["className", "label"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

const _svs$tickets$next$uti = svs.tickets.next.utils.utils,
  getCalloutAlignment = _svs$tickets$next$uti.getCalloutAlignment,
  getCalloutLines = _svs$tickets$next$uti.getCalloutLines;
const cn = function () {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(' ');
};
const Callout = _ref => {
  let className = _ref.className,
    label = _ref.label,
    props = _objectWithoutProperties(_ref, _excluded);
  const lines = getCalloutLines(label);
  if (lines.length === 0) {
    return null;
  }
  const hasTwoLines = lines.length === 2;
  const callOutAlignment = getCalloutAlignment(lines);
  const calloutClassName = cn('tickets-next-callout-label', hasTwoLines && 'tickets-next-callout-label--two-rows', callOutAlignment && "tickets-next-callout-label--".concat(callOutAlignment), className);
  return React.createElement("span", _extends({
    className: calloutClassName
  }, props), lines.map((line, index) => React.createElement("span", {
    className: "tickets-next-callout-label__line",
    key: "".concat(index, "-").concat(line)
  }, line)));
};
setGlobal('svs.tickets.next.components.nova.Callout', Callout);

 })(window);